var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCaratRightSkinny(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 15.214l1.393 1.393L14 10 7.393 3.393 6 4.786 11.213 10 6 15.214z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0iI2JlYmViZSI+CiAgICA8cGF0aCBkPSJNNiAxNS4yMTM4TDcuMzkzMDkgMTYuNjA2OUwxNCA5Ljk5OTk4TDcuMzkzMDkgMy4zOTMwN0w2IDQuNzg2MTVMMTEuMjEzMSA5Ljk5OTk4TDYgMTUuMjEzOFoiIGZpbGw9IiNiZWJlYmUiIC8+Cjwvc3ZnPgo=";
export { SvgCaratRightSkinny as ReactComponent };